import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';
const statusColors = {
    active: 'bg-green-500',
    pending: 'bg-yellow-500',
    disabled: 'bg-gray-500',
    accepted: 'bg-green-500',
    expired: 'bg-red-500',
    revoked: 'bg-red-500',
};
const statusKeys = {
    active: 'users.status.active',
    pending: 'users.status.pending',
    disabled: 'users.status.disabled',
    accepted: 'users.status.accepted',
    expired: 'users.status.expired',
    revoked: 'users.status.revoked',
};
export function StatusIndicator({ status, className, showLabel = true }) {
    const { t } = useTranslation('settings');
    return (_jsxs("span", { className: cn('inline-flex items-center gap-1.5', className), children: [_jsx("span", { className: cn('h-2 w-2 rounded-full', statusColors[status]) }), showLabel && (_jsx("span", { className: "text-muted-foreground text-sm capitalize", children: t(statusKeys[status]) }))] }));
}
